import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useSearchParams } from "react-router-dom";
import { company, navItems } from "../data/site";

function tabLink(path, tab) {
  return tab ? `${path}?tab=${tab}` : path;
}

function matchNavItem(pathname) {
  return navItems.find((item) => {
    if (item.path === "/news") return pathname.startsWith("/news");
    if (item.path === "/jobIndex") {
      return pathname === "/jobIndex" || pathname === "/job";
    }
    return pathname === item.path;
  });
}

export default function Header() {
  const location = useLocation();
  const [params] = useSearchParams();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const current = matchNavItem(location.pathname);
  const subItems = current?.children;
  const activeTab = params.get("tab") || subItems?.[0]?.tab;

  return (
    <header className={`site-header ${subItems ? "has-sub" : ""}`}>
      <div className="header-main">
        <div className="container header-inner">
          <Link to="/" className="brand" aria-label={company.name}>
            <span>
              <strong>{company.shortName}</strong>
              <small>{company.englishName}</small>
            </span>
          </Link>

          <button
            className={`nav-toggle ${open ? "is-open" : ""}`}
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>

          <nav className={`main-nav ${open ? "is-open" : ""}`}>
            {navItems.map((item) => (
              <div className="nav-item" key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => {
                    const onJoin =
                      item.path === "/jobIndex" &&
                      (location.pathname === "/job" ||
                        location.pathname === "/jobIndex");
                    return `nav-link ${isActive || onJoin ? "is-active" : ""}`;
                  }}
                >
                  {item.label}
                </NavLink>
                {item.children && (
                  <div className="nav-drop">
                    {item.children.map((child) => (
                      <Link
                        key={child.label}
                        to={tabLink(child.path, child.tab)}
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <Link to="/contact" className="nav-cta">
              联系我们
            </Link>
          </nav>
        </div>
      </div>

      {subItems && (
        <div className="header-sub">
          <div className="container sub-nav">
            {subItems.map((child) => (
              <Link
                key={child.label}
                to={tabLink(child.path, child.tab)}
                className={activeTab === child.tab ? "is-active" : ""}
              >
                {child.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
